import { Panel } from '../../ui/Panel';
import { Field } from '../../ui/Field';
import { Toggle } from '../../ui/Toggle';
import { pillars } from '../socialOptions';
import { inputCls } from '../../ui/styles';
import type { SocialPost } from '../../../core/types/social';
type Props = {
  post: SocialPost;
  set: (patch: Partial<SocialPost>) => void;
};

/** Werktitel en soort bericht (voor de mix), met toestemming bij resultaten. */
export function PostTopicPanel({
  post,
  set
}: Props) {
  return <Panel title="Onderwerp" data-id="element-4529" data-mp="3qkdm6jkku5p2">
      <div className="space-y-5" data-id="element-4530" data-mp="3mgfq6hqjtb08">
        <Field label="Werktitel" hint="Alleen voor jou, zodat je hem terugvindt in de planner." data-id="element-4531" data-mp="3mhh9talmr5tk">
          <input value={post.title} onChange={e => set({
          title: e.target.value
        })} className={inputCls} data-id="element-4532" data-mp="3hoo5gnu2pzi0" />
        </Field>
        <Field label="Soort bericht" as="div" data-id="element-4533" data-mp="3cp1t0gm2kna9">
          <div role="radiogroup" aria-label="Soort bericht" className="grid gap-2 sm:grid-cols-2" data-id="element-4534" data-mp="e1e0l0evd934">
            {pillars.map(p => {
            const on = post.pillar === p.key;
            return <button key={p.key} type="button" role="radio" aria-checked={on} onClick={() => set({
              pillar: p.key
            })} className={`flex items-start gap-2.5 rounded-md px-3 py-2.5 text-left transition-colors duration-150 ease-soft ${on ? 'bg-shell ring-2 ring-ink' : 'bg-white ring-1 ring-line hover:ring-ink/30'}`} data-id="element-4535" data-mp="3ud8g8ze3u5h">
                  <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${p.dot}`} aria-hidden="true" data-id="element-4536" data-mp="3m7ulnjaw0n7c" />
                  <span data-id="element-4537" data-mp="388botmnj0yac">
                    <span className="block text-[14px] text-ink" data-id="element-4538" data-mp="3894l1tov05e8">{p.label}</span>
                    <span className="block text-[12px] leading-snug text-muted" data-id="element-4539" data-mp="3ca6lueyfcpib">{p.text}</span>
                  </span>
                </button>;
          })}
          </div>
        </Field>
        {post.pillar === 'resultaat' && <Toggle checked={post.consent} onChange={consent => set({
        consent
      })} label="De cliënt heeft toestemming gegeven" description="Schriftelijk (bijv. per WhatsApp) voor deze foto of dit verhaal. Bewaar het bericht." data-id="element-4540" data-mp="1affszmojiayc" />}
      </div>
    </Panel>;
}